import { useState, useEffect } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
}

// Breakpoint helpers based on Tailwind breakpoints
// Mobile: < 768px (below md breakpoint)
// Tablet: 768px - 1023px (md to just below lg)
// Desktop: >= 1024px (lg and above)
export const useIsMobile = () => useMediaQuery('(max-width: 767px)');
export const useIsTablet = () => useMediaQuery('(min-width: 768px) and (max-width: 1023px)');
export const useIsDesktop = () => useMediaQuery('(min-width: 1024px)');

// Combined hooks for common patterns
export const useIsTabletOrDesktop = () => useMediaQuery('(min-width: 768px)');
export const useIsMobileOrTablet = () => useMediaQuery('(max-width: 1023px)');
